/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';
import CardInfo3 from '@components/Card/CardInfo3';
import StyleConfig from '@components/UI/Common/StyleConfig';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { fetchBiolinkPageData } from 'services/landingPageService';
import { getLandingPaths } from 'services/othersService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Center Landing Page Data
 */

const BioLink = ({ region, language, pageData }) => {
  const pageBody = pageData.body;
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
        pageconfig={pageData?.pageConfig}
      >
      </HeadComponent>
      <Box as="section" className="page-wrap container-article" p="0">
        <Box as="div" display="block" minH="115px" mb="60px">
        <StyleConfig
          id={pageBody[0]?.sectionId}
          key={pageBody[0].sectionId}
          style={pageBody[0]?.styleConfig}
        >
          <Box display="flex" alignContent="center" justifyContent="center" alignItems="center" p={{base:'20px', md:'20px'}}>
            <Link href={pageBody[0]?.sectionContent[1]?.text}>
              <LazyLoadImageComponent
                src={pageBody[0]?.sectionContent[0]?.image?.url}
                alt={pageBody[0]?.sectionContent[0]?.image?.alt}
                title={pageBody[0]?.sectionContent[0]?.image?.title}
              />
            </Link>
          </Box>
        </StyleConfig>
        </Box>
        <CardInfo3
          sectionContent={pageBody[1]?.sectionContent[0]}
          region={region}
          lang={language}
          isLeftMenu=""
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const instaLandingPaths = config.USE_LOCAL_URL
    ? [`/in/en/instagram-link-bio`]
    : await getLandingPaths('lvl0', '/instagram-link-bio');
  return {
    paths: instaLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, others },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchBiolinkPageData(region, language, `${others}`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default BioLink;
